import styles from './Breadcrumbs.module.scss'
import { ChevronRightIcon } from '@heroicons/react/24/outline'
import cn from 'classnames'
import Link from 'next/link'

function Breadcrumbs({ breadcrumbs = [], className, ...props }) {
  if (!breadcrumbs.length) return null

  return (
    <nav
      className={cn(styles['root'], { [className]: className })}
      aria-label="Breadcrumb"
      {...props}
    >
      <ol>
        {breadcrumbs.map((breadcrumb, index) => {
          const isLabel = !breadcrumb.uri && !breadcrumb.children
          const isLink = breadcrumb.uri

          return (
            <li
              key={index}
              className={cn({ [styles['label']]: isLabel, [styles['link']]: isLink })}
            >
              {isLabel && <span>{breadcrumb.title}</span>}

              {isLink && <Link href={breadcrumb.uri}>{breadcrumb.title}</Link>}

              {index !== breadcrumbs.length - 1 && <ChevronRightIcon className={cn(styles['separator'])} />}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

export default Breadcrumbs
